import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class JWTService {
  constructor(private readonly auth: AuthService) {}

  checkAuthToken(): string {
    if (this.auth.getAuthToken()) {
      return this.auth.getAuthToken();
    } else {
      return '';
    }
  }

  checkDeviceToken(): string {
    if (this.auth.getDeviceToken()) {
      return this.auth.getDeviceToken();
    } else {
      return '';
    }
  }
}
